import * as swcHelpers from '@swc/helpers';
import '../../types.js';
import { fromStoreQueryDataToStoreDetails } from '../../hooks/api/adapters/fromStoreQueryDataToStoreDetails.js';
import { fromNearestStoresQueryToNearestStores } from '../../hooks/api/adapters/fromNearestStoresQueryToNearestStores.js';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import { GET_STORE_DETAILS } from '../../operations/queries/get-store-details.js';
import { GET_NEAREST_STORES } from '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';

function getPageData(apolloClient, slugOrCode, locale) {
    return _getPageData.apply(this, arguments);
}
function _getPageData() {
    _getPageData = swcHelpers.asyncToGenerator(function*(apolloClient, slugOrCode, locale, withNearestStores = false, maxDistance) {
        try {
            var ref;
            const storeQuery = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_DETAILS,
                variables: {
                    [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = (ref = storeQuery.data) === null || ref === void 0 ? void 0 : ref.store;
            const storeData = fromStoreQueryDataToStoreDetails(storeQueryData);
            if (storeQuery.error) {
                console.error(storeQuery.error);
            }
            const nearestStores = [];
            if (withNearestStores && (storeData === null || storeData === void 0 ? void 0 : storeData.lat) !== undefined && (storeData === null || storeData === void 0 ? void 0 : storeData.lon) !== undefined) {
                var ref1;
                const nearestStoresQuery = yield apolloClient.query({
                    query: GET_NEAREST_STORES,
                    variables: {
                        searchGeoLocation: {
                            lat: storeData === null || storeData === void 0 ? void 0 : storeData.lat,
                            lon: storeData === null || storeData === void 0 ? void 0 : storeData.lon
                        },
                        forceDistance: true,
                        maxResults: 2,
                        maxDistance,
                        filter: {
                            excludeGlobalStoreId: `${storeData === null || storeData === void 0 ? void 0 : storeData.globalStoreId}`
                        }
                    }
                });
                const nearestStoresQueryData = (ref1 = nearestStoresQuery.data) === null || ref1 === void 0 ? void 0 : ref1.storesByDistance;
                var ref2;
                nearestStores.push(...(ref2 = fromNearestStoresQueryToNearestStores(nearestStoresQueryData)) !== null && ref2 !== void 0 ? ref2 : []);
                if (nearestStoresQuery.error) {
                    console.error(nearestStoresQuery.error);
                }
            }
            return {
                storeData,
                nearestStores
            };
        } catch (e) {
            console.error(e);
            return {
                storeData: null,
                nearestStores: []
            };
        }
    });
    return _getPageData.apply(this, arguments);
}

export { getPageData };
//# sourceMappingURL=data.js.map
